/* eslint-disable no-param-reassign */
import { call, put, takeLatest } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';

import SDK from 'utils/sdk';
import { messageError } from 'views/ui/toast-message';
import { listRegions, retrieveRegion } from './actions';

export function* listRegionsSaga() {
  try {
    yield put(listRegions.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'regionListWithLocations'], {});
    yield put(listRegions.success(data));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(listRegions.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(listRegions.fulfill());
  }
}

export function* retrieveRegionSaga({ payload: { id } }) {
  try {
    yield put(retrieveRegion.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'regionOne'], { id });
    yield put(retrieveRegion.success(data));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(retrieveRegion.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(retrieveRegion.fulfill());
  }
}

export default function* authWatch() {
  yield takeLatest(listRegions.TRIGGER, listRegionsSaga);
  yield takeLatest(retrieveRegion.TRIGGER, retrieveRegionSaga);
}
